import type { TripAccommodationStay } from '~/services/engine-ts';
import type { StayTransformed } from '~/types/JourneyItem.types';
import { isBywayFavouriteAccommodation } from '~/utils/accommodationHelpers';

const EMPTY_GEO = { latitude: 0, longitude: 0 };

export function transformTripAccommodationToStay(stay: TripAccommodationStay): StayTransformed {
  const { accommodation } = stay;
  const roomName = accommodation.selectedRooms?.[0]?.displayName ?? accommodation.roomName ?? null;
  const body: StayTransformed['body'] = [];

  if (accommodation.description) {
    body.push({
      id: `${stay.itemId}-description`,
      type: 'text',
      text: accommodation.description
    });
  }

  body.push({
    id: `${stay.itemId}-accommodation`,
    type: 'accommodation',
    defaultAccommodation: {
      id: String(accommodation.id),
      accommodationId: accommodation.id,
      itemId: stay.itemId,
      title: accommodation.title,
      nights: stay.nights,
      selected: true,
      accommodation: {
        title: accommodation.title,
        description: accommodation.description ?? '',
        url: accommodation.websiteUrl,
        handpicked: false,
        boardBasis: accommodation.selectedRooms.some((room) => room.boardBasis === 'BB') ? 'BB' : 'RO',
        roomName: roomName ?? '',
        displayName: roomName ?? '',
        favourite: isBywayFavouriteAccommodation(accommodation.ranking ?? 0)
      },
      image: accommodation.images[0] ?? { src: '' },
      cmsId: accommodation.cmsId,
      geoCoordinates: null
    },
    alternativeAccommodation: null,
    pinnedAccommodationCmsIds: null,
    pinnedRoomsInHotel: null
  });

  return {
    type: 'Stay',
    id: String(stay.itemId),
    stayItemId: stay.itemId,
    startDate: stay.checkIn,
    endDate: stay.checkOut,
    title: stay.placeName,
    nights: stay.nights,
    geoCoordinates: EMPTY_GEO,
    images: accommodation.images,
    body,
    carbonFootprint: 0,
    country: { countryId: '', countryName: '', cmsId: '' }
  };
}

export function transformTripAccommodationStays(stays: TripAccommodationStay[]): StayTransformed[] {
  return stays.map(transformTripAccommodationToStay);
}
